module.exports = __webpack_public_path__ + "img/ywbj@2x.f3aafe34.png";